import { Injectable } from '@angular/core';
import { WebApiService } from '../web-api/web-api.service';
import { AcceptHeaderFactoryService } from '../http/headers/accept-header-factory.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private webApiService: WebApiService, private acceptHeaderFactoryService: AcceptHeaderFactoryService) { }

  getEmail() {
    return this.webApiService.get("/identity/email", {
      headers: {
        ...this.createAcceptHeader("application/json"),
      },
      addInstanceIdHeader: false,
    });
  }

  createAcceptHeader(value) {
    return this.acceptHeaderFactoryService.createHeader(value);
  }
}
